import { render } from "./ProductPatterns.vue?vue&type=template&id=2c58620e&scoped=true"
import script from "./ProductPatterns.vue?vue&type=script&lang=js"
export * from "./ProductPatterns.vue?vue&type=script&lang=js"

import "./ProductPatterns.vue?vue&type=style&index=0&id=2c58620e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c58620e"]])

export default __exports__